/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 11/07/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en corte de caja
*      3       | 01/06/2026 | Lic. José Luis Aragón Cervantes  | Eliminaciones movidas a otras acciones
 *      4       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Acceso rápido a devoluciones
 *      5       | 11/06/2026 | Lic. José Luis Aragón Cervantes  | Cierra venta super al navegar a devoluciones (replace)
* ---------------------------------------------------------------------------------------
*/

import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import VerifiedIcon from "@mui/icons-material/Verified";
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from "@mui/icons-material/Print";
import HomeIcon from "@mui/icons-material/Home";
import DensitySmallIcon from "@mui/icons-material/DensitySmall";

import SearchIcon from "@mui/icons-material/Search";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import AssignmentReturnIcon from "@mui/icons-material/AssignmentReturn";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import NextPlanIcon from "@mui/icons-material/NextPlan";

import FrmLoginValidate from '../administracion/FrmLoginValidate';

import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useSesion } from "../../context/System/SesionContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from '../../hooks/useDoubleClickPrevention';

export default function MnuVentasActions({ disabled, onOpenBuscador, onOpenReimpresion, onOpenValePorCambio }) {
  const { parametrosCajaForm } = useSesion();
  const { isProcessing, executeWithProtection } = useDoubleClickPrevention();
  const navigate = useNavigate();

  const {
    handleClickRegresarMainDashboard,
    handleClickNuevaVenta,
    handleClickRefrescarDatosVenta,
    handleAbrirMenuModal,
    handleArirModalCobrarVenta,
    handleImprimirTicket,
    handleOpenModalLoginValidatorCortes,
    handleArirModalBuscarArticulos,
    handleArirModalBuscarCliente,
    handleAbrirModalJalarPreVentaCotizacion,
    listaRemisionTemporal
  } = useVentas();

  return (
    <Fragment>
      <Tooltip title={"Home"}>
        <IconButton onClick={handleClickRegresarMainDashboard}>
          <HomeIcon className="icon" /><p className="icon"> Salir</p>
        </IconButton>
      </Tooltip>

      <Tooltip title={"Jalar Preventas (Alt+J)"}>
        <span>
          <IconButton
            onClick={() => executeWithProtection(() => handleAbrirModalJalarPreVentaCotizacion("PREVENTA"))}
            disabled={isProcessing || disabled}
          >
            <NextPlanIcon className="icon" /><p className="icon">Preventas</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={"Buscar Artículos (Alt+F1)"}>
        <span>
          <IconButton onClick={() => {
            if (onOpenBuscador) onOpenBuscador();
            handleArirModalBuscarArticulos();
          }} disabled={disabled}>
            <SearchIcon className="icon" /><p className="icon">Artículos</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={"Buscar Clientes (Alt+F2)"}>
        <span>
          <IconButton onClick={handleArirModalBuscarCliente} disabled={disabled}>
            <PersonSearchIcon className="icon" /><p className="icon">Clientes</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={"Ir a devoluciones"}>
        <span>
          <IconButton onClick={() => navigate("/devoluciones", { replace: true })}>
            <AssignmentReturnIcon className="icon" /><p className="icon">Devoluciones</p>
          </IconButton>
        </span>
      </Tooltip>

      {listaRemisionTemporal.length > 0 && (
        <Tooltip title={"Cobrar"}>
          <span>
            <IconButton onClick={() => executeWithProtection(handleArirModalCobrarVenta)} disabled={isProcessing || disabled}>
              <VerifiedIcon className="icon" /><p className="icon">Cobrar</p>
            </IconButton>
          </span>
        </Tooltip>
      )}

      <Tooltip title="Refrescar datos">
        <span>
          <IconButton onClick={handleClickRefrescarDatosVenta} disabled={disabled}>
            <RefreshIcon className="icon" />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={"Reimprimir ticket anterior"}>
        <span>
          <IconButton onClick={onOpenReimpresion}>
            <PrintIcon className="icon" /><p className="icon">Reimprimir</p>
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title="Generar vale por cambio">
        <span>
          <IconButton onClick={onOpenValePorCambio} disabled={disabled}>
            <ReceiptLongIcon className="icon" /><p className="icon">Vale</p>
          </IconButton>
        </span>
      </Tooltip>

      {/* ✅ CORTES SE QUEDAN IGUAL */}
      <Tooltip title="Generar corte de caja">
        <span>
          <IconButton onClick={() => executeWithProtection(handleOpenModalLoginValidatorCortes)} disabled={isProcessing || disabled}>
            <VerifiedIcon className="icon" />
          </IconButton>
        </span>
      </Tooltip>

      <Tooltip title={"acciones_venta"}>
        <span>
          <IconButton onClick={handleAbrirMenuModal}>
            <DensitySmallIcon className="icon" /><p className="icon">Menu</p>
          </IconButton>
        </span>
      </Tooltip>
    </Fragment>
  );
}
